<template>
    <b-container fluid>
        <hr/>
        <h3>Cron subscribers</h3>
        <hr/>
        <b-button-group>
            <v-btn v-b-modal.create_cron_subscriber_modal :style="primaryStyle" :loading="loadingCreate"
                   :disabled="loadingCreate">New subscriber
            </v-btn>
        </b-button-group>
        <hr/>
        <v-skeleton-loader
                :loading="this.loadingIndex"
                transition='fade-transition'
                ref="skeleton"
                type="table"
                class="mx-auto"
                width="100%">
            <b-table striped :items="subscribers"
                     :fields="['id', 'name', 'project_name', 'interval','event_name', 'active', 'edit', 'delete']">
                <template slot="edit" slot-scope="data">
                    <b-button @click="editCronSubscriber(data.item)" variant="primary">Edit</b-button>
                </template>
                <template slot="delete" slot-scope="data">
                    <b-button @click="deleteCronSubscriber(data.item)" variant="danger">Delete</b-button>
                </template>
            </b-table>
        </v-skeleton-loader>

        <create-subscriber v-bind:project_options="project_options"
                           v-bind:event_options="event_options"
                           @cron-subscriber-created="cronSubscriberCreated"
                           @change-create-loading="loadingCreate = !loadingCreate">
        </create-subscriber>
        <edit-subscriber v-bind:selected_cron_subscriber="to_edit_cron_subscriber"
                         v-bind:event_options="event_options"
                         @cron-subscriber-edited="cronSubscriberEdited"
                         @show-loading-pop-up="showLoadingPopUp"
                         @reset-loading-pop-up="resetLoadingPopUp">
        </edit-subscriber>
    </b-container>
</template>

<script>
    import CronSubscriberRepository from '../../repositories/cron_subscriber.repository';
    import EventRepository from "../../repositories/event.repository";
    import ProjectRepository from '../../repositories/project.repository';
    import CreateSubscriber from './Create.vue';
    import EditSubscriber from './Edit.vue';

    export default {
        data() {
            return {
                subscribers: [],
                events: [],
                projects: [],
                to_edit_cron_subscriber: CronSubscriberRepository.blankSubscriber(),
                loadingIndex: false,
                loadingCreate: false,
            }
        },
        components: {
            CreateSubscriber,
            EditSubscriber,
        },
        created() {
            this.loadingIndex = true;
            CronSubscriberRepository.getAll().then(res => {
                this.subscribers = res.data["hydra:member"];
                this.loadingIndex = false;
            }).catch(error => {
                this.loadingIndex = false;
            });
            EventRepository.getAll().then(res => {
                this.events = res.data.events;
            });
            ProjectRepository.getAll().then(res => {
                this.projects = res.data["hydra:member"];
            });
        },
        methods: {
            showLoadingPopUp(text) {
                this.$emit('show-loading-pop-up', text);
            },
            resetLoadingPopUp() {
                this.$emit('reset-loading-pop-up');
            },
            cronSubscriberCreated(subscriber) {
                this.subscribers.push(subscriber);
            },
            cronSubscriberEdited(subscriber) {
                this.subscribers.forEach(e => {
                    if (e.id === subscriber.id) Object.assign(e, subscriber);
                });
            },
            editCronSubscriber(subscriber) {
                // Clone the selected item so that it can be edited without changing the original.
                this.to_edit_cron_subscriber = Object.assign({}, subscriber);
                // Show the edit modal.
                this.$bvModal.show('edit_cron_subscriber_modal');
            },
            deleteCronSubscriber(subscriber) {
                this.$emit('show-loading-pop-up', 'Deleting the selected cron subscriber.');
                CronSubscriberRepository.delete(subscriber.id).then(res => {
                    // Status 204 means no content, which is the response we would expect when deleting a record.
                    if (res.status === 204) {
                        this.$emit('reset-loading-pop-up');
                        // Remove the cron Subscriber from the local list to reflect the deletion.
                        this.subscribers = this.subscribers.filter(u => u.id !== subscriber.id);
                        // Notify the user.
                        this.$bvToast.toast(`Cron subscriber ${subscriber.name} successfully deleted.`, {
                            title: `Cron  deleted.`,
                            variant: 'success',
                            solid: true
                        });
                    } else {
                        // If the status is not 204 something must have gone wrong.
                        // So we notify the user with a toast.
                        this.$bvToast.toast('Looks like something went wrong while deleting a cron subscriber.', {
                            title: `Cron subscriber deletion error.`,
                            variant: 'danger',
                            solid: true
                        });
                    }
                }).catch(error => {
                    this.$emit('reset-loading-pop-up');
                    this.$bvToast.toast('Looks like something went wrong while deleting a cron subscriber.', {
                        title: `Cron subscriber deletion error.`,
                        variant: 'danger',
                        solid: true
                    });
                });
            }
        },
        computed: {
            project_options() {
                return this.projects.map(p => {
                    return {value: p.id, text: p.id + " - " + p.name};
                });
            },
            event_options() {
                return this.events.map(e => {
                    return {value: e.name, text: e.name};
                });
            }
        }
    }
</script>
